import { getStoryBySlug, searchStories } from "../story/requests";
import { Article } from "./entities";
import { articleSlugFromPath } from "../../helpers/URLHelpers";

const getArticleBySlug = (path) => {
  return getStoryBySlug(articleSlugFromPath(path)).then((data) =>
    Article(data.story, data.rels, data.adv)
  );
};

const getLegacyArticleBySlug = (path) => {
  return getStoryBySlug(path).then((data) =>
    Article(data.story, data.rels, data.adv)
  );
};

const getArticlesByAuthorName = ({ name, page, pageSize }) =>
  searchStories({ author: name, page, pageSize });

export { getArticleBySlug, getArticlesByAuthorName, getLegacyArticleBySlug };
